/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Class used to define the duration of a loan
 */
export type LoanDurationOptionDTO = {
    /**
     * Indicates which chronological group is used
     */
    chronoUnit?: LoanDurationOptionDTO.chronoUnit;
    /**
     * Duration id
     */
    id?: number;
    /**
     * Indicates the amount of time
     */
    unit?: number;
};

export namespace LoanDurationOptionDTO {

    /**
     * Indicates which chronological group is used
     */
    export enum chronoUnit {
        NANOS = 'Nanos',
        MICROS = 'Micros',
        MILLIS = 'Millis',
        SECONDS = 'Seconds',
        MINUTES = 'Minutes',
        HOURS = 'Hours',
        HALF_DAYS = 'HalfDays',
        DAYS = 'Days',
        WEEKS = 'Weeks',
        MONTHS = 'Months',
        YEARS = 'Years',
        DECADES = 'Decades',
        CENTURIES = 'Centuries',
        MILLENNIA = 'Millennia',
        ERAS = 'Eras',
        FOREVER = 'Forever',
    }


}
